import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Mail } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Erreur");
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <div className="max-w-md mx-auto px-6 py-20 text-center" data-testid="forgot-password-sent">
        <div className="w-20 h-20 mx-auto rounded-full bg-terracotta/10 flex items-center justify-center mb-6">
          <Mail size={36} className="text-terracotta" />
        </div>
        <p className="font-accent text-3xl text-terracotta -rotate-2 mb-2">Vérifiez vos e-mails</p>
        <h1 className="font-serif-display text-3xl mb-4">E-mail envoyé</h1>
        <p className="text-[#6B655C] mb-8">Si cette adresse est associée à un compte, vous recevrez un lien de réinitialisation. Le lien est valable 30 minutes.</p>
        <Link to="/login" className="text-sm text-terracotta hover:underline">Retour à la connexion</Link>
      </div>
    );
  }

  return (
    <div className="max-w-md mx-auto px-6 py-20" data-testid="forgot-password-page">
      <p className="font-accent text-3xl text-terracotta -rotate-2 mb-2 text-center">Pas de panique</p>
      <h1 className="font-serif-display text-4xl mb-3 text-center">Mot de passe oublié</h1>
      <p className="text-sm text-[#6B655C] text-center mb-10">Saisissez votre adresse e-mail et nous vous enverrons un lien pour le réinitialiser.</p>
      <form onSubmit={submit} className="bg-white/70 backdrop-blur-md rounded-3xl border border-[#E5E1D8] p-8 space-y-4">
        <div>
          <label htmlFor="forgot-email" className="block text-sm text-[#6B655C] mb-1.5">Adresse e-mail</label>
          <input id="forgot-email" required type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="votre@email.com" className="w-full p-3 rounded-2xl border border-[#E5E1D8] focus:outline-none focus:border-terracotta" data-testid="forgot-email-input" />
        </div>
        <button type="submit" disabled={loading} className="btn-primary w-full justify-center disabled:opacity-50" data-testid="forgot-submit-btn">
          {loading ? "Envoi..." : "Envoyer le lien"}
        </button>
      </form>
      <p className="text-center text-sm text-[#6B655C] mt-6">
        <Link to="/login" className="text-terracotta hover:underline">Retour à la connexion</Link>
      </p>
    </div>
  );
}
